import { useContext } from 'react';
import { ToastContext } from './Toast.context';

export const useToastContext = () => {
  const toastContext = useContext(ToastContext);
  if (toastContext === undefined) {
    throw new Error('useToastContext must be inside of ToastContext');
  }
  return toastContext;
};
